var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04574 20.5618C9.31809 19.2895 9.31808 17.2266 8.04574 15.9543C6.7734 14.6819 4.71053 14.6819 3.43819 15.9543C2.57033 16.8221 2.17184 19.3643 2.00618 20.8929C1.93656 21.5353 2.46469 22.0634 3.10709 21.9938C4.63572 21.8282 7.17789 21.4297 8.04574 20.5618Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9491 3.05039C22.2532 6.02929 21.1839 9.00969 19.0429 11.1506L17.6847 12.5089C14.9596 12.6629 12.765 14.8009 12.5223 17.5013C12.2611 17.564 11.9767 17.4952 11.7755 17.2939L6.70612 12.2245C6.39567 11.9141 6.40032 11.4061 6.71649 11.09L7.09019 10.7163L5.84576 10.1026L4.26429 9.4367C3.97801 9.31615 3.90931 8.9423 4.13244 8.71917L6.17012 6.68149C6.94392 5.90769 8.10232 5.67442 9.09513 6.09247L9.63049 6.3179L10.8749 6.93154L12.8494 4.95706C14.9903 2.81614 17.9707 1.74685 20.9496 2.05091C21.4798 2.10502 21.895 2.52017 21.9491 3.05039Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C18.4338 14 18.8514 14.0691 19.2426 14.1968L17.989 15.4504C17.6085 15.8308 17.0273 15.9251 16.5461 15.6845L15.291 15.057C16.0035 14.4008 16.955 14 18 14Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18C14 17.385 14.1388 16.8024 14.3867 16.2819L15.8753 17.0262C16.934 17.5555 18.2126 17.348 19.0496 16.511L20.6003 14.9604C21.3979 15.6434 21.9236 16.6349 21.9923 17.75C20.6331 17.753 17.7024 18.5412 16.3388 21.6398C14.9588 21.009 14 19.6165 14 18Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8282 21.9964C17.8851 21.9988 17.9424 22 18 22C19.7697 22 21.271 20.8507 21.7983 19.2578C20.7903 19.3314 18.8535 19.9506 17.8282 21.9964Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketEarth);
export default __webpack_public_path__ + "static/media/rocket-earth.c3f82db4a58d9f7329eb6245cc10538c.svg";
export { ForwardRef as ReactComponent };